import React, { Component } from 'react';
import axios from 'axios';
import firebase from '../../firebase';
import FileUploader from 'react-firebase-file-uploader';
import Loading from '../../components/Loading';

import { ADD_LOCATION,
         CHECK_URL,
         DIETARY_INFO_URL,
         EDIT_LOCATION_URL,
         SEND_MENUS
} from '../../config'; 

import {
         ALPHANUMERIC_ERROR,
         DIET_DESCRIPTIONS,
         DIET_NAMES_FORMATTED,
         DIET_TAGS,
         MAX_LOCATION_MESSAGE,
         NAME_ADDRESS_MISSING,
         UPLOAD_ERROR,
         URL_ERROR,
         URL_INVALID,
         URL_VALID
} from './constants';
import Header from '../Header/Header';

class LocationForm extends Component {
    constructor(props){
        super(props);
        this.state = {
            name: props.locationProperties ? this.props.locationProperties.name : '',
            address: props.locationProperties ? this.props.locationProperties.address : '',
            city: '',
            menuLink: '',
            menuUpload: '',
            policy: '',
            lowCarb: false,
            kosher: false,
            halal: false,
            glutenFree: false,
            gfFoodPrep: false,
            tamariSauce: false,
            gfFriendly: false,
            vegan: false,
            veganFriendly: false,
            vegetarian: false,
            veggieFriendly: false,
            allergyFriendly: false,
            err: '',
            url: '',
            urlError: URL_ERROR,
            urlValid: false,
            submitting: false,
            isUploading: false,
            uploadError: false,
        }
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handlePolicyChange = this.handlePolicyChange.bind(this);
        this.sendMenus = this.sendMenus.bind(this);

        this.handleUploadStart = this.handleUploadStart.bind(this);
        this.handleUploadError = this.handleUploadError.bind(this);
        this.handleUploadSuccess = this.handleUploadSuccess.bind(this);
        if(this.props.locationProperties) this.retrieveDietaryInformation();
    }

    /**
     * Encodes form input into diet tag vector
     * @return diet tag vector
     */
    generateDietTagVector(){
        let currentVector = 0;
        for(let i = 0; i<DIET_TAGS.length; i++){
            if(this.state[DIET_TAGS[i]["name"]])
                currentVector = currentVector | DIET_TAGS[i]["value"]
        }
        return currentVector; 
    }

    /**
     * Decodes form input based on diet tag vector
     * @param diet tag vector
     */
    decodeDietTagVector(dietTagVector){
        let currentTags = DIET_TAGS;
        let newState = {};
        for(let i = 0; i<currentTags.length; i++){
            if((dietTagVector & currentTags[i]["value"]) == currentTags[i]["value"]){
                newState[currentTags[i]["name"]] = true;
            }
            else{
                newState[currentTags[i]["name"]] = false;
            }
        }
        this.setState(newState);
    }

    /**
     * Generates a valid URL string by removing alphanumeric and adding a dash
     * @param name
     * @return alphanumeric string from name
     */
    generateHyphenatedName(name){
        name = name.toLowerCase();
        name = name.trim();
        name = name.replace(/[^A-Za-z0-9\s]/g, '');
        name = name.replace(/ /g, '-');
        return name;
    }

    /**
     * Determines whether or not a name is a valid url
     * @param name
     * @return true if valid, false otherwise
     */
    testURL(name){
        for(let i = 0; i < name.length; i++){
            let code = name.charCodeAt(i);
            //More space efficient to encode here than to make 8 constants
            if (!(code > 47 && code < 58) && // numeric (0-9)
            !(code > 64 && code < 91) && // upper alpha (A-Z)
            !(code > 96 && code < 123) && //lower alpha (a-z)
            !(code == 32) && // space
            !(code == 45)) { // dash
                return false;
            }
        }
        return true;
    }

    /**
    * Generates a filename composed of the restaurant name and a random string
    */
    generateFileName(){
        let restaurantName = this.state.name.replace(/\s+/, "-");
        let randomString = Math.random().toString(36).substring(6);
        return restaurantName + '-' + randomString;
    }

    /**
     * Signal that file uploading has started
     */
    handleUploadStart(){
        this.setState({isUploading: true});
    }

    /**
     * Signal error on file upload
     * @param error : name of error
     */    
    handleUploadError(error){
        this.setState({isUploading: false, uploadError: true});
    }
    
    /**
     * Upon success of image saving, adds the file name of saved image to menuUpload link
     * @param filename : name of file to save  
     */
    handleUploadSuccess(filename){
        let currentMenuName = this.state.menuUpload;
        if (currentMenuName == "") this.setState({menuUpload: filename, isUploading: false});
        else{
          currentMenuName += ', ';
          currentMenuName += filename;
          this.setState({menuUpload: currentMenuName, isUploading: false}); 
        }
    }

    /**
     * Send request to add a restaurant
     */
    postLocation(){
        if (this.state.submitting) return;

        this.setState({submitting: true});

        if(!this.state.name || !this.state.address){
            this.setState({err: NAME_ADDRESS_MISSING, submitting: false});
            return;
        }

        if(this.state.uploadError){
            this.setState({err: UPLOAD_ERROR, submitting: false});
        }

        if(this.props.locations >= this.props.locationMax){
            this.setState({err: MAX_LOCATION_MESSAGE, submitting: false});
            return;
        }
        let self = this;
        axios.post(
          ADD_LOCATION(),
          {
            "name": self.state.name,
            "address": self.state.address + ' ' + self.state.city,
            "dietaryPolicy": self.state.policy,
            "dietTagVector": self.generateDietTagVector(),
          },
          {
            headers: {
              "Authorization": self.props.client.token,
              "Content-Type": "application/json"
            }
          }
        ).then(function(response){
          self.sendMenus(response.data.locations);
          self.props.updateClient();
        })
        .catch(function(err){
        })
    }

    /**
     * Send request to edit a restaurant
     */
    updateLocation(){
        if (this.state.submitting) return;

        this.setState({submitting: true});

        if(!this.state.name || !this.state.address){
            this.setState({err: NAME_ADDRESS_MISSING, submitting: false});
            return;
        }

        let self = this;
        axios.post(
          EDIT_LOCATION_URL(self.props.locationProperties._id),
          {
            "name": self.state.name,
            "address": self.state.address,
            "dietaryPolicy": self.state.policy,
            "dietTagVector": self.generateDietTagVector(),
          },
          {
            headers: {
              "Authorization": self.props.client.token,
              "Content-Type": "application/json"
            }
          }
        ).then(function(response){
          self.setState({submitting: false});
          self.props.doneAddingLocation();
          self.props.updateClient();
        })
        .catch(function(err){
        })
    }    

    

    /**
     * Send request to upload menu now that the location has been added
     * @param Locations: list of restaurant locations
     */
    sendMenus(locations){
        let id = locations[locations.length - 1]["id"]
        let self = this;
        axios.post(
            SEND_MENUS(),
            {
                "name": self.state.name,
                "id": id,
                "menus": [self.state.menuLink, self.state.menuUpload],
                "email": self.props.client.email,
                "address": self.state.address
            },
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        ).then(function(response){
            self.setState({submitting: false});
            self.props.doneAddingLocation();
        })
        .catch(function(err){
        });
    }

  /**
   * API call to retrieve the dietary information of a restaurant by id
   */
  retrieveDietaryInformation(){
    let id = this.props.locationProperties._id;
    let self = this;
    axios.get(
        DIETARY_INFO_URL(id),
        {
            headers: {
                "Authorization": self.props.client.token,
                "Content-Type": "application/json"
            }
        }
    ).then(function(response){
        if(response.data){
            self.setState({
                policy: response.data.dietaryPolicy,
            })
            self.decodeDietTagVector(response.data.dietTagVector);
        }          
    }).catch(function(err){

    })
    }    

    /**
     * API call to check if a url has been used or not
     */
    checkURL(url){
        this.setState({url});

        if(!this.testURL(url)){
            this.setState({urlError: ALPHANUMERIC_ERROR, urlValid: false});
            return;
        }

        if(url.length < 3) {
            this.setState({urlError: URL_ERROR, urlValid: false});
            return;
        }
        let self = this;

        axios.get(
            CHECK_URL(url)
        ).then(function(response){
            self.setState({urlError: URL_VALID, urlValid: true});
        })
        .catch(function(err){
            self.setState({urlError: URL_INVALID, urlValid: false});
        });

    }
    /**
     * Callback for when the restaurant name is changed.
     * Modifies restaurant shortURL
     */
    handleNameChange(event){
        let name = event.target.value;
        this.setState({name});
    }

    /**
     * Callback for when dietary policy is changed
     */
    handlePolicyChange(event){
        let policy = event.target.value;
        this.setState({policy});
    }

    /**
     * Renders rows of diet table for each diet
     * Each row contains a name, switch and description
     * @return diets : table rows
     */
    renderDietRows(){
        let diets = Object.keys(DIET_DESCRIPTIONS).map((diet) => 
        <tr key = {diet}>
            <td>{DIET_NAMES_FORMATTED[diet]}</td>
            <td>
                <label className="switch switch-primary switch-3d switch-primary">
                    <input
                        className="switch-input form-check-input"
                        type="checkbox"
                        checked={this.state[diet]}
                        value={this.state[diet]}
                        onChange={() => { 
                            let obj = {};
                            obj[diet] = !this.state[diet];
                            this.setState(obj); 
                        }}
                    />
                    <span className="switch-label"></span>
                    <span className="switch-handle"></span>
                </label>
            </td>
            <td>{DIET_DESCRIPTIONS[diet]}</td>
        </tr>
        );
        return diets;
    }

    /**
     * @return table to let users choose what diets their location supports
     */
    get dietQuestions(){
        return (
            <div className="col-12">
            <div className="card">
               <div className="p-0 card-body">
                  <table className="table-align-middle mb-0 table table-striped table-hover">
                     <thead>
                        <tr>
                           <th>Diet</th>
                           <th>Switch</th>
                           <th>Description</th>
                        </tr>
                     </thead>
                     <tbody>
                         {this.renderDietRows()}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>        
        )
    }

    /**
     * Render spinner
     */
    get spinner(){
        return (
            <div className="form-spinner">
                <Loading />
            </div>           
        )
    }

    /**
     * Return JSX element for city form. 
     * Only show city field if not editing 
     */
    get cityField(){
        if(this.props.editLocation) return null;
        return(
            <div>
                <h5 className="field-heading">City</h5>
                <input
                    type="text"
                    placeholder="Enter the city of your location"
                    className="form-control short-text-input"
                    value={this.state.city}
                    onChange={(event) => this.setState({ city: event.target.value })}
                />
            </div>
        )    
    }

    get generalInformation() {
        return (
        <div className="card">
            <div className="card-body">
                <div className="form-group">
                    <h5 className="card-title"> General Information </h5>
                    <h5 className="field-heading">Name</h5>
                    <input
                        type="text"
                        id="company"
                        placeholder="Enter the name of your location"
                        className="form-control short-text-input"
                        value={this.state.name}
                        onChange={this.handleNameChange}
                    />
                    <h5 className="field-heading">Address</h5>
                    <input
                        type="text"
                        id="company"
                        placeholder="Enter the address of your location"
                        className="form-control short-text-input"
                        value={this.state.address}
                        onChange={(event) => this.setState({ address: event.target.value })}
                    />
                    {this.cityField}
                </div>
            </div>
        </div>
        );
    }

    get menuUploadSection() {
        return (
            <div>
                <h5>Menu Links</h5>
                <textarea
                    type="text"
                    id="company"
                    placeholder="Enter links to your menus separated by comma or space (5 links max for free users)"
                    className="form-control"
                    onChange={(event) => this.setState({ menuLink: event.target.value })}
                />
                <p>If you do not have a link to your menu, you can also upload files.</p>
                <FileUploader
                    multiple
                    name="Menu"
                    className="uploader"
                    filename={() => this.generateFileName()}
                    storageRef={firebase.storage().ref('images')}
                    onUploadStart={this.handleUploadStart}
                    onUploadError={this.handleUploadError}
                    onUploadSuccess={this.handleUploadSuccess}
                />
                {this.state.uploadError ?
                    <div className="alert alert-danger" role="alert">
                        {this.state.urlError}
                    </div>
                    : null
                }

                {this.state.isUploading ? this.spinner : null}

            </div>
        )
    }

    get addMenuSection() {
        return (
            <div className="card">
                <div className="card-body">
                    <div className="form-group">
                        <h5 className="card-title"> Dietary Information </h5>
                        {!this.props.editLocation && this.menuUploadSection}
                        <h5 className="field-heading">Restaurant Diet Questions</h5>
                        {this.dietQuestions}

                        <h5>Dietary Policy (Optional)</h5>
                        <textarea
                            type="textarea"
                            className="form-control short-text-input"
                            placeholder="Enter a short version of your dietary policy for users here (1000 characters max)"
                            value={this.state.policy}
                            onChange={this.handlePolicyChange}
                        />
                        {
                            this.state.policy && this.state.policy.length > 1000 ?
                                <div className="alert alert-danger" role="alert">
                                    Max 1000 characters!
                                        </div>
                                : null
                        }
                    </div>
                </div>
            </div>
        );
    }


    /**
     * Render submission buttons
     */
    get submissionSection() {
        return (
            <div>
                <div>
                    {this.state.submitting ? this.spinner : null}
                    {this.state.err == '' ? null :
                        <div className="alert alert-primary" role="alert">
                            {this.state.err}
                        </div>
                    }
                </div>
                <div>
                    <button
                        type="submit"
                        className="btn btn-primary btn-lg locationSubmit"
                        disabled={this.state.submitting ? "disabled" : ""}
                        onClick={() => {
                                if (this.props.editLocation) this.updateLocation();
                                else this.postLocation();
                            }
                        }
                    >
                        Submit
                </button>
                    <button
                        type="reset"
                        className="btn btn-danger btn-lg locationCancel"
                        onClick={this.props.cancelAddingLocation}
                    >
                        Cancel
                 </button>
                 </div>
            </div>
        );
    }

    get header(){
        return(
          <Header
            pageName= {this.props.editLocation ? "EDIT LOCATION" : "ADD NEW LOCATION"}
          />
        )
      }

    render(){
        return(
            <div>
                {this.header}
                <div className="pageContainer">
                    <h5 className="page-header">
                        {this.props.editLocation ? "EDIT LOCATION" : "ADD NEW LOCATION"}
                    </h5>
                    <div className="col-xl-6 col-lg-12">
                        {this.generalInformation}
                        {this.addMenuSection}
                        {this.submissionSection}
                    </div>
                </div>
            </div>
        )
    }
}

export default LocationForm;


// WEBPACK FOOTER //
// ./src/components/LocationForm/LocationForm.js